import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useHoverable } from "@gemini/core";
import { ArrowRightIcon } from "@gemini/icons";
import { PartnerBoxLogo } from "./PartnerBoxLogo";
import { useI18n } from "@/contexts/i18n";
import { useTestId, useTrackingProductClick } from "@/hooks";
import { DsaElement } from "@/components";
import { useClassified } from "@/contexts/classified";
import { useAdsContext } from "@/ads/context";
import { useConfig } from "@/contexts/cdpConfig";
export const isValidDistributionKey = (validDistributionKeys, currentDistribution) => {
    if (!validDistributionKeys || (validDistributionKeys === null || validDistributionKeys === void 0 ? void 0 : validDistributionKeys.length) < 1)
        return null;
    return validDistributionKeys.some((dist) => dist === currentDistribution);
};
export const PartnerBoxAds = ({ partner }) => {
    var _a, _b;
    const { t } = useI18n();
    const { targeting } = useAdsContext();
    const partnerAd = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.partnerAd;
    const currentDistribution = String(targeting === null || targeting === void 0 ? void 0 : targeting.IMMO_DISTRIBUTION);
    if (!partner ||
        !isValidDistributionKey(partner === null || partner === void 0 ? void 0 : partner.validDistributionKeys, currentDistribution) ||
        !(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd))
        return null;
    return (_jsxs(Box, { marginTop: "spacing.24", children: [_jsx(DsaElement, {}), _jsxs(AdButtonCard, { partnerName: partner.name, url: partner.url, pageViewGA4: partner.pageViewGA4, children: [_jsx(AdLogo, { children: partner.withLogo ? (_jsx(PartnerBoxLogo, { partnerKey: partner.name })) : null }), _jsx(AdTitle, { children: t(partner.text) }), _jsx(AdArrowRightIcon, {})] })] }));
};
const AdButtonCard = (props) => {
    const { boxProps, isHovered } = useHoverable();
    const handleTrackingProductClick = useTrackingProductClick(props.partnerName);
    const isPreviewMode = useConfig().previewMode;
    const handleLinkClick = () => {
        if (isPreviewMode)
            return;
        handleTrackingProductClick();
        window.open(props.url, "_blank");
    };
    return (_jsx(Box, { testId: useTestId("Sections.Price.Modal.PartnerBoxAds.Card"), as: "button", ...boxProps, onClick: handleLinkClick, display: "flex", flexDirection: "row", width: "100%", paddingHorizontal: "spacing.16", paddingVertical: "spacing.24", cursor: "pointer", backgroundColor: isHovered ? "color.background.light" : "color.background.default", borderStyle: "solid", borderRadius: "radius.16", borderColor: "color.border.light.default", children: props.children }));
};
const AdLogo = ({ children }) => (_jsx(Box, { alignSelf: "center", children: children }));
const AdTitle = ({ children }) => (_jsx(Box, { testId: useTestId("Sections.Price.Modal.PartnerBoxAds.Card.Title"), alignSelf: "center", paddingLeft: "spacing.8", typography: "typography.body.16.bold", textAlign: "left", children: children }));
const AdArrowRightIcon = () => (_jsx(Box, { alignSelf: "center", flexGrow: "1", textAlign: "right", children: _jsx(ArrowRightIcon, { opacity: "opacity.70" }) }));
